module.exports = __webpack_public_path__ + "static/media/edit_student_schedule_navigate_students.69a5eeb4.mov";